import React from 'react'
import styled from '@emotion/styled'
import { Icon } from 'antd'
import { colors, elements } from 'style/theme'

const StyledFormFooter = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridGap: 1,
  padding: 0
})

const BaseButton = styled.div({
  padding: 10,
  fontWeight: 700,
  cursor: 'pointer'
})

const StyledCancel = styled(BaseButton)({
  background: colors.brandDark,
  color: '#C2C2C2',
  borderBottomLeftRadius: elements.brandBorderRadius - 1
})

const StyledOK = styled(BaseButton)({
  background: colors.brandButton,
  color: '#fff',
  borderBottomRightRadius: elements.brandBorderRadius - 1
})

const FormFooter = ({ onClose, onOK, okText, confirmLoading }) => {
  return (
    <StyledFormFooter>
      <StyledCancel onClick={onClose}>CANCEL</StyledCancel>
      <StyledOK onClick={onOK}>
        <span>{okText}</span> {confirmLoading && <Icon type="loading" />}
      </StyledOK>
    </StyledFormFooter>
  )
}

export default FormFooter
